<div class="authentification">
  <div class="wrapper row row d-lg-flex align-items-center" *ngIf="IsAdded == false">
    <div class="col-md-6" style="padding: 48px 156px 20px 156px; background-color: #fff !important;">
      <div class="w-desktop">
        <div class="row">
          <!-- <div class="col-md-1 col-sm-1 col-xs-1 icon_left">
           <i class="material-icons">
               west
           </i>
         </div> -->
          <div class="col-md-11 col-sm-11 col-xs-11" style="margin-bottom: 40px;">
            <a href="/"><img src="../../../assets/images/conversell-logo.png" alt="Conversell"></a>
          </div>
        </div>
        <div class=" pr-2 mx-auto mt-3 mb-3">
          <h1>Sign up </h1>
          <div class="mentionBlock">
            <span class="descTitle">Start for free</span>
            <span class="descTitle">* No credit card required</span>
          </div>
          <!-- <h2> <img src="../../../assets/images/plane.png" alt="Conversell" style=" width: 30px;"><span>Start your UNLIMITED free trial today!</span></h2>
     <p class="under_title_signup">Try Conversell AI-powered channels for free, and explore 
       all the features <br> and services you need to grow your business.</p> -->
          <form [formGroup]="userDetailForm" (ngSubmit)="submitted = true" class="card_design">
            <div class="form-group">
              <label class="Label__Text">Email *</label>
              <div floatLabel="always">
                <input type="email" formControlName="email" required pInputText placeholder="" />
              </div>
              <mat-error
                *ngIf="userDetailForm.controls['email'].touched && userDetailForm.controls['email'].hasError('required')">
                This field is required
              </mat-error>
              <mat-error
                *ngIf="userDetailForm.controls['email'].touched &&  userDetailForm.controls['email'].hasError('email')">
                Enter a valid email address.
              </mat-error>
              <mat-error *ngIf="userAlreadyExist">
                <!-- <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="home"></mat-icon> -->
                {{userAlreadyExist}}
              </mat-error>
            </div>
            <div class="form-group">
              <label class="Label__Text">Password *</label> <br>
              <div class="inputpassword">
                <input formControlName="password" [type]="hidepass ? 'password' : 'text'" minlength="8" pInputText
                  placeholder="" required />
                <button mat-icon-button matSuffix (click)="hidepass = !hidepass" [attr.aria-label]="'Hide password'"
                  [attr.aria-pressed]="hidepass">
                  <mat-icon>{{hidepass ? 'visibility_off' : 'visibility'}}</mat-icon>
                </button>
              </div>
              <mat-error *ngIf=" submitted && userDetailForm.controls['password'].hasError('required')">
                Please insert a valid password.
              </mat-error>
              <mat-error *ngIf="submitted && userDetailForm.controls['password'].hasError('minlength')">
                password must be at least 8 characters long.
              </mat-error>
            </div>
            <div class="form-group">
              <label class="Label__Text">Confirm Password*</label>
              <div class="inputpassword">
                <input formControlName="confirm_password" [type]="hidepass2 ? 'password' : 'text'" required pInputText
                  placeholder="" />
                <button mat-icon-button matSuffix (click)="hidepass2 = !hidepass2" [attr.aria-label]="'Hide password'"
                  [attr.aria-pressed]="hidepass2">
                  <mat-icon>{{hidepass2 ? 'visibility_off' : 'visibility'}}</mat-icon>
                </button>
              </div>
              <mat-error
                *ngIf="submitted &&  (userDetailForm.controls['confirm_password'].value !== userDetailForm.controls['password'].value )">
                password does not match
              </mat-error>
            </div>
            <div class="LinkPassword">
              <mat-checkbox required (change)="Iaccept($event)" [(ngModel)]="accept" formControlName="accept">
                <span>I accept the <a href="https://conversell.ai/terms-of-use.html" target="_blank"
                    style="color: #418987;">Terms of
                    use</a></span>
              </mat-checkbox>
              <p *ngIf="!accept && userDetailForm.controls['accept'].touched">Please accept the Terms of use!</p>
            </div>
            <div class="form-group">
              <div class="btn-1 text-center">
                <button [disabled]=" !accept || userDetailForm.invalid " (click)="registerClient()"
                  class="btn d-block w-100">Get Strated</button>
              </div>
              <div class="row mt-3 mb-3">
                <div class="col-md-5 col-5">
                  <div class="divider"></div>
                </div>
                <div class="col-md-2 col-2 p-0">
                  <h2 class="line_devider text-center">
                    OR
                  </h2>
                </div>
                <div class="col-md-5 col-5">
                  <div class="divider"></div>
                </div>
              </div>
              <div class="btn-defaut btn-login">
                <button type="button" id="gmail" class="d-block w-100 margBott12" (click)="signInWithGoogle()">Sign up
                  with Gmail</button>
                <div id="buttonDiv"></div>
                <button type="button" id="facebook" class="d-block w-100 margBott12" (click)="signInWithFB()">Sign up
                  with Facebook</button>
                <div id="buttonDiv"></div>
                <button type="button" id="facebook" class="d-block w-100" (click)="signInWithAmazon()">Sign up with
                  Amazon</button>
              </div>
            </div>
            <div class="loginDescription">
              <p><span class="sign-up">Already have an account? <a routerLink="/auth/login">Log in here.</a></span></p>
            </div>
          </form>

        </div>
        <div class="row">
          <div class="text_term-privacy">
            <p style="margin-bottom : 0 ;">
              By clicking "Get Started", you acknowledge that you have read and understood,
              and agree to Conversell's <a href="https://www.conversell.ai/terms-of-use.html" target="_blank"> "Terms of
                use" </a> and <a target="_blank" href="https://www.conversell.ai/privacy-policy-solution.html"> "Privacy
                Policy" </a>
            </p>
          </div>
        </div>
        <!-- <a routerLink="/forget-password" class="help">Need help?</a> -->
      </div>
    </div>
    <div class="col-md-6 text-lg-end">
      <img src="../../../../../assets/images/screen_mockup.png" alt="">
    </div>
  </div>

  <body class="regsiter-body"></body>
  <script type="text/javascript" src="angular-recaptcha.js"></script>
</div>